import { render, staticRenderFns } from "./IndicatorWithTitle.vue?vue&type=template&id=58b0810e&"
import script from "./IndicatorWithTitle.vue?vue&type=script&lang=js&"
export * from "./IndicatorWithTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IndicatorWithTitle.vue"
export default component.exports